import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: var(--spacing-05) var(--spacing-06);

  @media (prefers-color-scheme: dark) {
    color: var(--white-100);
  }
`;
const HelperTextWrapper = styled.p`
  border: 1px solid var(--cool-gray-50);
  padding: var(--spacing-02) var(--spacing-04);
`;

export const CmdkFooter: React.FC = () => {
  return (
    <FooterWrapper>
      <HelperTextWrapper>
        <FormattedMessage id="cmdk.footer.helper_text" />
      </HelperTextWrapper>
    </FooterWrapper>
  );
};
